import { Actions } from './virtualAppsUI.actions';
import * as actions from './virtualAppsUI.actions';
import {
  SubChatScreens,
  SCREEN_STATUS,
  PageDirection,
  ListRequestDetails
} from '../../../models/constants';
import { SubChatUI } from 'src/models/SubGroupUI';

const INITIAL_STATE: SubChatUI = {
  selectedSubGroup: null,
  creationProcessSubChat: null,
  currentSubChatScreen: SubChatScreens.SUB_CHAT_LIST,
  eop: 0,
  currentPage: [],
  hash: '',
  status: SCREEN_STATUS.IDLE,
  direction: null,
  previousRequest: {}
};

export function virtualAppUiReducer(
  state = INITIAL_STATE,
  action: Actions
): SubChatUI {
  switch (action.type) {
    case actions.VirtualAppUIActionTypes.UI_LIST_VIRTUAL_APP: {
      return {
        ...state,
        selectedSubGroup: null,
        creationProcessSubChat: null,
        currentSubChatScreen: SubChatScreens.SUB_CHAT_LIST,
        eop: 0,
        currentPage: [],
        hash: '',
        status: SCREEN_STATUS.IDLE
      };
    }
    case actions.VirtualAppUIActionTypes.UI_CREATE_VIRTUAL_APP: {
      const res = {
        ...state,
        selectedSubGroup: null,
        creationProcessSubChat: null,
        currentSubChatScreen: SubChatScreens.SUB_CHAT_CREATION
      };
      return res;
    }
    case actions.VirtualAppUIActionTypes.UI_VIEW_VIRTUAL_APP: {
      return {
        ...state,
        selectedSubGroup: action.selectedVirtualApp,
        creationProcessSubChat: null,
        currentSubChatScreen: SubChatScreens.SUB_CHAT_VIEW
      };
    }
    case actions.VirtualAppUIActionTypes.UI_EDIT_VIRTUAL_APP: {
      return {
        ...state,
        selectedSubGroup: action.selectedVirtualApp,
        creationProcessSubChat: null,
        currentSubChatScreen: SubChatScreens.SUB_CHAT_EDIT
      };
    }
    case actions.VirtualAppUIActionTypes.UI_UPLOAD_VIRTUAL_APP_PHOTO: {
      if (state.currentSubChatScreen === SubChatScreens.SUB_CHAT_EDIT) {
        return state;
      } else {
        return {
          ...state,
          creationProcessSubChat: action.createdVirtualApp,
          currentSubChatScreen: SubChatScreens.SUB_CHAT_PHOTO_UPLOADING
        };
      }
    }
    case actions.VirtualAppUIActionTypes.UI_VIRTUAL_APP_CREATION_COMPLETE: {
      return {
        ...state,
        creationProcessSubChat: null,
        currentSubChatScreen: SubChatScreens.SUB_CHAT_LIST
      };
    }

    case actions.VirtualAppUIActionTypes.UI_CLOSE_VIEW_VIRTUAL_APP: {
      return {
        ...state,
        selectedSubGroup: null,
        creationProcessSubChat: null,
        currentSubChatScreen: SubChatScreens.SUB_CHAT_LIST
      };
    }

    case actions.VirtualAppUIActionTypes.UI_CLOSE_EDIT_VIRTUAL_APP: {
      return {
        ...state,
        creationProcessSubChat: null,
        currentSubChatScreen: SubChatScreens.SUB_CHAT_VIEW
      };
    }
    case actions.VirtualAppUIActionTypes.UI_VIRTUAL_APP_GET_NEXT_PAGE: {
      return {
        ...state,
        direction: PageDirection.NEXT,
        status: SCREEN_STATUS.REQUESTING
      };
    }
    case actions.VirtualAppUIActionTypes.UI_VIRTUAL_APP_GET_PREV_PAGE: {
      return {
        ...state,
        direction: PageDirection.PREV,
        status: SCREEN_STATUS.REQUESTING
      };
    }
    case actions.VirtualAppUIActionTypes.UI_VIRTUAL_APP_SET_IDLE_STATUS: {
      return {
        ...state,
        status: SCREEN_STATUS.IDLE
      };
    }
    case actions.VirtualAppUIActionTypes
      .UI_VIRTUAL_APP_RECEIVED_HISTORY_CHUNK: {
      const prevRequest: ListRequestDetails = {};
      prevRequest.eop = state.eop;
      prevRequest.sop = state.sop;
      prevRequest.hash = state.hash;
      prevRequest.direction = state.direction;
      return {
        ...state,
        previousRequest: prevRequest,
        eop: action.eop ? action.eop : state.eop,
        sop: action.sop ? action.sop : state.sop,
        status: SCREEN_STATUS.IDLE,
        currentPage:
          (action.currentPage && action.currentPage.length) > 0
            ? action.currentPage
            : state.currentPage
      };
    }
    case actions.VirtualAppUIActionTypes.UI_VIRTUAL_APP_RESET_PAGING: {
      return {
        ...state,
        eop: 0,
        sop: null,
        currentPage: [],
        hash: '',
        status: SCREEN_STATUS.IDLE,
        direction: null,
        previousRequest: {}
      };
    }
    case actions.VirtualAppUIActionTypes.RESET:
      return INITIAL_STATE;
    default: {
      return state;
    }
  }
}
